import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { getInitialColor, getInitials } from "../../services/commonServices";
import { Form } from "react-bootstrap";

const Index = ({
    width = "sm",
    isOpen,
    closeOpenDialog,
    submitForm,
    isHeader1,
    dialogTitle,
    dialogTitleSec = "",
    buttonTitle,
    buttonTitleSec,
    isEdit = false,
    body
}) => {
    return (
        <Dialog
            fullWidth={true}
            maxWidth={width}
            open={isOpen}
            onClose={closeOpenDialog}
            style={{ zIndex: "99999999" }}
        >
            <Form>
                <DialogTitle className="dialog-title d-flex align-items-center">
                    {
                        isHeader1 ? <>
                            <div className="dialog-title-icon">
                                <span className="close-icon" onClick={closeOpenDialog}>
                                    X
                                </span>
                                <span className="title"> {isEdit ? dialogTitleSec : dialogTitle} </span>
                                <br />
                            </div>
                            {
                                buttonTitle != "" ? <button className="universal-btn" onClick={submitForm}>
                                    {isEdit ? buttonTitleSec : buttonTitle}
                                </button> : null
                            }
                        </>
                        :
                        <>
                            <div className="dialog-title-icon">
                                <span className="title"> {isEdit ? dialogTitleSec : dialogTitle} </span>
                            </div>

                            <span className="close-icon" onClick={closeOpenDialog}>
                                X
                            </span>
                        </>
                    }
                </DialogTitle>
                <DialogContent style={{ paddingTop: "15px" }}>
                    {body}
                </DialogContent>
            </Form>
        </Dialog>
    );
};

export default Index;
